import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function MkpIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path class="st0" d="M21.79,3.5c-0.01-0.01-0.01-0.02-0.02-0.03c-0.02,0.01-0.04,0.01-0.06,0.02c-1.35,0.61-2.78,0.85-4.25,0.88
		C16.3,4.4,15.15,4.32,14,4.2c-1.34-0.13-2.69-0.27-4.04-0.38c-1.29-0.1-2.58-0.06-3.85,0.2C4.7,4.31,3.42,4.88,2.29,5.77
		C2.26,5.8,2.22,5.87,2.22,5.91c0,1.31,0.01,2.61,0.01,3.92c0,0.15,0,0.29,0,0.46c0.04-0.04,0.07-0.07,0.09-0.09
		c0.28-0.33,0.6-0.64,0.96-0.89c0.87-0.63,1.85-0.99,2.88-1.25C7.4,7.76,8.67,7.62,9.94,7.47c1.26-0.14,2.52-0.27,3.78-0.44
		C14.87,6.89,16,6.65,17.11,6.3c1.43-0.46,2.76-1.11,3.91-2.1C21.28,3.98,21.53,3.73,21.79,3.5z M18.72,12.66
		c0-0.01-0.01-0.01-0.01-0.02c-0.03,0.02-0.07,0.03-0.1,0.04c-0.59,0.27-1.21,0.48-1.84,0.65c-1.25,0.33-2.53,0.45-3.82,0.42
		c-1.12-0.02-2.23-0.07-3.35-0.09c-0.98-0.03-1.96,0.03-2.93,0.23c-1.64,0.33-3.09,1.07-4.39,2.1c-0.04,0.03-0.07,0.1-0.07,0.15
		c0,1.41,0.01,2.82,0.01,4.23c0,0.03,0.01,0.07,0.01,0.11c0.21-0.22,0.4-0.45,0.61-0.64s0.43-0.39,0.66-0.57
		c0.86-0.65,1.84-1.08,2.86-1.41c1.14-0.36,2.32-0.6,3.49-0.86c1.17-0.26,2.34-0.53,3.47-0.93c2.03-0.7,3.82-1.79,5.31-3.34
		C18.66,12.73,18.69,12.7,18.72,12.66z M2.23,15.3c0.04-0.04,0.07-0.07,0.09-0.1c0.66-0.8,1.45-1.43,2.43-1.8
		c0.81-0.31,1.65-0.41,2.51-0.48c0.85-0.06,1.71-0.11,2.55-0.2c0.85-0.09,1.67-0.3,2.47-0.63c1.27-0.52,2.34-1.32,3.31-2.28
		c0.1-0.1,0.2-0.21,0.3-0.32c-0.02-0.01-0.02-0.01-0.03-0.01c-0.12,0.05-0.23,0.1-0.35,0.15c-0.92,0.39-1.87,0.64-2.87,0.66
		c-0.76,0.03-1.5-0.08-2.24-0.26C9.65,9.84,8.89,9.63,8.13,9.44C6.88,9.15,5.66,9.23,4.47,9.75c-0.77,0.34-1.48,0.8-2.15,1.32
		c-0.07,0.05-0.09,0.11-0.09,0.21c0,1.31,0,2.61,0,3.91C2.23,15.22,2.23,15.25,2.23,15.3z"/>
	<path d="M21.79,3.5c-0.26,0.24-0.51,0.49-0.77,0.71c-1.15,0.98-2.47,1.64-3.91,2.1C16,6.66,14.87,6.9,13.72,7.05
		c-1.25,0.16-2.52,0.29-3.78,0.44C8.67,7.62,7.4,7.76,6.15,8.08C5.12,8.33,4.14,8.69,3.28,9.32C2.93,9.58,2.6,9.87,2.32,10.21
		c-0.03,0.03-0.04,0.05-0.09,0.09c0-0.17,0-0.32,0-0.46c0-1.31-0.01-2.61-0.01-3.92c0-0.05,0.03-0.11,0.08-0.15
		c1.13-0.89,2.41-1.47,3.83-1.75c1.27-0.26,2.56-0.3,3.85-0.2c1.35,0.1,2.69,0.25,4.04,0.38c1.15,0.11,2.3,0.21,3.46,0.17
		c1.47-0.03,2.89-0.27,4.25-0.88c0.02-0.01,0.04-0.02,0.06-0.02C21.78,3.48,21.78,3.49,21.79,3.5z"/>
	<path d="M18.72,12.66c-0.03,0.03-0.06,0.07-0.09,0.1c-1.49,1.56-3.28,2.64-5.31,3.34c-1.13,0.39-2.3,0.67-3.47,0.93
		c-1.17,0.26-2.34,0.49-3.49,0.86c-1.02,0.33-2,0.75-2.86,1.41c-0.23,0.17-0.45,0.37-0.66,0.57c-0.21,0.2-0.4,0.42-0.61,0.64
		c0-0.04-0.01-0.08-0.01-0.11c-0.01-1.41-0.01-2.82-0.01-4.23c0-0.05,0.03-0.13,0.07-0.15c1.31-1.04,2.75-1.78,4.39-2.1
		c0.97-0.2,1.95-0.25,2.93-0.23c1.12,0.03,2.23,0.08,3.35,0.09c1.29,0.03,2.57-0.09,3.82-0.42c0.63-0.17,1.25-0.39,1.84-0.65
		c0.03-0.02,0.07-0.03,0.1-0.04C18.72,12.65,18.72,12.66,18.72,12.66z"/>
	<path d="M2.23,15.3c0-0.05-0.01-0.08-0.01-0.11c0-1.31,0-2.61,0-3.91c0-0.09,0.03-0.15,0.1-0.21c0.67-0.52,1.37-0.98,2.15-1.32
		c1.18-0.52,2.41-0.6,3.66-0.3c0.76,0.18,1.52,0.39,2.28,0.59c0.74,0.19,1.48,0.28,2.24,0.26c1-0.03,1.95-0.27,2.87-0.66
		c0.12-0.05,0.23-0.1,0.35-0.15c0,0,0.01,0,0.03,0.01c-0.1,0.1-0.21,0.21-0.3,0.32c-0.96,0.96-2.04,1.76-3.31,2.28
		c-0.8,0.33-1.62,0.54-2.47,0.63c-0.85,0.09-1.7,0.14-2.55,0.2s-1.7,0.17-2.51,0.48c-0.98,0.37-1.77,1-2.43,1.8
		C2.3,15.23,2.27,15.25,2.23,15.3z"/>
</g>
      </svg>
    </SvgIcon>
  )
}
